import React, { useEffect, useState } from 'react';
import './App.css';
import firebase from 'firebase/app';
import { firebaseConfig } from './interfaces/connection';
import AuthService from './services/auth_service';
import { HashRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import Login from './pages/login';
import './bulma.min.css';
import Home from './pages/home';
import Privacity from './pages/privacity';


if (firebase.apps.length === 0) {
  firebase.initializeApp(firebaseConfig);
}

const App: React.FC = () => {
  const [isAuth, setAuth] = useState(false);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    new AuthService().isAuth((state: boolean) => {
      setAuth(state);
      setTimeout(() => {
        setLoading(false);
      }, 400);
    });
  }, []);

  const secureRoute = (page: object, params?: { require: boolean }) => {
    const isRequired = (params?.require || false);

    if (isRequired && isAuth) {
      return <Redirect to="/home" />
    }

    if (isAuth === false) {
      return <Login />;
    }

    return page;
  }

  if (isLoading) {
    return (
      <div className="container-loading-app">
        <span className="icon">
          <i className="fab fa-cloudsmith"></i>
        </span>
        <h1>Cargando App</h1>
      </div>
    );
  }

  return (
    <Router>
      <div className="modal-backdrop isOculted" id="modal-general">
        <div className="modal-app">
          <div className="close-modal" onClick={() => {
            const modal = document.querySelector("#modal-general") as HTMLDivElement;

            if (modal.className !== "modal-backdrop isOculted") {
              modal.className = "modal-backdrop isOculted";
              const modalContent = document.querySelector("#modal-general-content") as HTMLDivElement;

              const newElement = document.createElement("div");
              newElement.setAttribute("class", "modal-content");
              newElement.setAttribute("id", "modal-general-content");

              modalContent.replaceWith(newElement);
            }
          }}>
            Cerrar
          </div>
          <div className="modal-content" id="modal-general-content">

          </div>
        </div>
      </div>
      <Switch>
        <Route path="/login" render={() => secureRoute(<Login />, { require: true })} exact />
        <Route path="/home" render={() => secureRoute(<Home />)} exact />
        <Route path="/privacidad" render={() => <Privacity />} exact />
        <Route path="/" render={() => <Redirect to="/login" />} exact />
      </Switch>
    </Router>
  );
};

export default App;
